import { TableCompHead } from '../../../../../components/ui';
import { useQuery } from '../../../../../hooks/UseQuery';

interface IProps {
  partData: any;
}

const THead = ({ partData }: IProps) => {
  const partLength = partData.length;
  return (
    <thead>
      <TableCompHead
        colSpan={5 + partLength}
        rowSpan={3}
        labels={['Doc No', 'Rev', 'Dated']}
        values={['FM-PRD-54 ', '00', '7-10-2023']}
        heading="MAN PART MATRIX"
      />
      <tr>
        <th rowSpan={2}>S.No.</th>
        <th rowSpan={2}>OPERATOR NAME</th>
        <th rowSpan={2}>Code</th>
        <th rowSpan={2}>Level</th>
        {partData.length > 0 && <th colSpan={partData.length}>PART NUMBER</th>}
        <th rowSpan={2}>REMARKS</th>
      </tr>
      <tr>
        {partData.map((part: any) => (
          <th>{part.part_number}</th>
        ))}
      </tr>
    </thead>
  );
};

export default THead;
